
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/resend-invite",
      function () {
        return require("private-next-pages/auth/resend-invite/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/resend-invite"])
      });
    }
  